var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{class:[
            'base-button base-button--ghost',
            _vm.disabled && 'base-button--disabled'
        ].filter(Boolean),attrs:{"href":_vm.fileUrl,"download":_vm.fileName}},[_c('span',{staticClass:"base-button__label"},[_vm._v("Download ICS")]),_vm._v(" "),_c('svg',{staticClass:"base-button__icon"},[_c('use',{attrs:{"xlink:href":"#icon-download"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }